import {
  CONSUMER_CREDIT_ROUTE,
  CONTACT_US_ROUTE,
  HOME_ROUTE,
  INSTALLMENT_PAYMENT_ROUTE,
  NORMATIVE_INFORMATION_AND_LEGAL_BASES_ROUTE,
  OFFICES_ROUTE,
  PORTABILITY_ROUTE,
  RATES_AND_FEES_ROUTE,
  FAQS_ROUTE,
} from './routes.constants';

export const TAG_TITLES = {
  [HOME_ROUTE]: 'Inicio - Solventa',
  [INSTALLMENT_PAYMENT_ROUTE]: 'Pagar Cuota - Solventa',
  [CONSUMER_CREDIT_ROUTE]: 'Crédito de consumo - Solventa',
  [CONTACT_US_ROUTE]: 'Atención al cliente - Solventa',
  [OFFICES_ROUTE]: 'Sucursales - Solventa',
  [RATES_AND_FEES_ROUTE]: 'Tasas y Tarifas - Solventa',
  [PORTABILITY_ROUTE]: 'Portabilidad financiera - Solventa',
  [NORMATIVE_INFORMATION_AND_LEGAL_BASES_ROUTE]: 'Información normativa y Bases legales - Solventa',
  [FAQS_ROUTE]: 'Preguntas frecuentes - Solventa',
};
